import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-result-confirmation-renvoi',
    templateUrl: './result-confirmation-renvoi.component.html',
    styleUrls: ['./result-confirmation-renvoi.component.scss'],
    imports: [MatDialogModule, TranslateModule]
})
export class ResultConfirmationRenvoiComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ResultConfirmationRenvoiComponent>) { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.dialogRef.close();
  }

}
